import { PortalApiError } from '../../types'

export const OAuthErrorCodes = {
  InvalidRequest: 'invalid_request',
  UnauthorizedClient: 'unauthorized_client',
  UnsupportedResponseType: 'unsupported_response_type',
  InvalidScope: 'invalid_scope',
  ServerError: 'server_error',
  AccessDenied: 'access_denied',
} as const
export type OAuthErrorCode = (typeof OAuthErrorCodes)[keyof typeof OAuthErrorCodes]

export const OAuthScopes = {
  ReadPaymentDetails: 'read_payment_details',
  ReadUserInfo: 'read_user_info',
  CreateCheckout: 'create_checkout',
} as const
export type OAuthScope = (typeof OAuthScopes)[keyof typeof OAuthScopes]

export const OAuthGrantTypes = {
  AuthorizationCode: 'authorization_code',
  RefreshToken: 'refresh_token',
} as const
export type OAuthGrantType = (typeof OAuthGrantTypes)[keyof typeof OAuthGrantTypes]

export interface ScopeAndDescription {
  scope: OAuthScope
  description: string[]
}

export interface ConfirmAccessRequest {
  params: {
    clientId: string
    grantType: OAuthGrantType
    redirectUri: string
    scopes: string[]
  }
}

export interface ConfirmAccessResponseBody {
  clientName: string
  consumerEmailId: string
  scopeAndDescription: ScopeAndDescription[]
}

export interface AuthorizeRequest {
  body: {
    clientId: string
    grantType: OAuthGrantType
    redirectUri: string
    scopes: OAuthScope[]
  }
}

export interface AuthorizeResponseBody {
  code: string
}

export interface Permission {
  clientId: string
  clientName: string
  grantedScopes: OAuthScope[]
}

export interface GetPermissionsResponseBody {
  consumerEmailId: string
  scopeAndDescription: ScopeAndDescription[]
  permissions: Permission[]
}

export interface DeletePermissionRequest {
  params: {
    clientId: string
  }
}

export type OAuthResponseType = 'authorization_code' | 'refresh_token' | null

export interface OAuthParams {
  readonly clientId?: string
  readonly responseType?: OAuthResponseType
  readonly redirectUri?: string
  readonly scope?: string
  readonly state?: string
}

export interface OAuthState extends OAuthParams {
  clientName?: string
  scopeAndDescription?: ScopeResponseRepresentation[]
  consumerEmailId: string
  error?: OAuthError
}

export interface ScopeResponseRepresentation {
  scope: string
  description: string[]
}
export type OAuthAccessDeniedError = 'access_denied'

export const OAUTH_ACCESS_DENIED_ERROR = 'access_denied'

export type OAuthError = PortalApiError | OAuthAccessDeniedError
